import isEmpty from 'lodash/isEmpty';

export type MultipleSelectFieldOption = {
	value: string;
	id: string;
	__typename?: string;
}[];

const constructValuesArray = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: (string | number)[];
	allowedValues: MultipleSelectFieldOption;
}) => {
	const values: MultipleSelectFieldOption = [];
	for (const defaultValues of defaultValue) {
		for (const isValue of allowedValues) {
			if (isValue.id === defaultValues?.toString()) {
				values.push({
					value: isValue.value,
					id: isValue.id,
				});
			}
		}
	}
	return values;
};

export const getMultipleSelectFieldValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): MultipleSelectFieldOption | null => {
	let values: MultipleSelectFieldOption = [];
	if (Array.isArray(allowedValues)) {
		if (Array.isArray(defaultValue)) {
			values = constructValuesArray({ defaultValue, allowedValues });
		}
		if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
			values = constructValuesArray({ defaultValue: [defaultValue], allowedValues });
		}

		return isEmpty(values) ? null : values;
	}
	return null;
};
